import {
  EnvironmentProviders,
  inject,
  provideEnvironmentInitializer,
} from "@angular/core";
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";

export const provideMatIconInitializer = (): EnvironmentProviders => {
  return provideEnvironmentInitializer(() => {
    const iconRegistry = inject(MatIconRegistry);
    const domSanitizer = inject(DomSanitizer);

    // Register Material icons
    iconRegistry.addSvgIconSet(
      domSanitizer.bypassSecurityTrustResourceUrl("./assets/mdi.svg")
    );
    iconRegistry.addSvgIcon(
      "vlm-ai",
      domSanitizer.bypassSecurityTrustResourceUrl("./assets/icons/vlm-ai.svg")
    );
    iconRegistry.addSvgIcon(
      "beta",
      domSanitizer.bypassSecurityTrustResourceUrl("./assets/icons/beta.svg")
    );
    iconRegistry.addSvgIcon(
      "merged",
      domSanitizer.bypassSecurityTrustResourceUrl("./assets/icons/merged.svg")
    );
    iconRegistry.addSvgIcon(
      "ai",
      domSanitizer.bypassSecurityTrustResourceUrl("./assets/icons/ai.svg")
    );
    iconRegistry.addSvgIcon(
      "refresh",
      domSanitizer.bypassSecurityTrustResourceUrl("./assets/icons/refresh.svg")
    );
    iconRegistry.addSvgIcon(
      "warning-outline",
      domSanitizer.bypassSecurityTrustResourceUrl("./assets/icons/warning-outline.svg")
    );
    iconRegistry.addSvgIcon(
      "pencil-outline",
      domSanitizer.bypassSecurityTrustResourceUrl("./assets/icons/pencil-outline.svg")
    );
    iconRegistry.addSvgIcon(
      "restore",
      domSanitizer.bypassSecurityTrustResourceUrl("./assets/icons/restore.svg")
    );
    iconRegistry.addSvgIcon(
      "video-slash",
      domSanitizer.bypassSecurityTrustResourceUrl("./assets/icons/video-slash.svg")
    );
    iconRegistry.addSvgIcon(
      "book-alt",
      domSanitizer.bypassSecurityTrustResourceUrl("./assets/icons/book-alt.svg")
    );
  });
};
